/** The ONE roles. A user holds one, alongside any other groups (e.g. service groups). */
export const ONE_ROLE_GROUPS = ['admin', 'partner_admin', 'customer'] as const;

export const PARTNER_ADMIN_ROLE = 'partner_admin';

export interface RoleOption {
  text: string;
  value: string;
}

/** Roles this editor can assign. Partner Admin isn't assignable here. */
export const ROLE_OPTIONS: RoleOption[] = [
  { text: 'Cyflare Admin', value: 'admin' },
  { text: 'Customer', value: 'customer' },
];

/** Shown read-only for users who already hold it, so saving them never demotes them. */
export const PARTNER_ADMIN_OPTION: RoleOption = { text: 'Partner Admin', value: PARTNER_ADMIN_ROLE };

/**
 * A user's ONE role. Users can hold several groups, so never assume `groups[0]` is the role.
 */
export function roleOf(groups: readonly string[] | null | undefined): string | null {
  const list = groups ?? [];
  return ONE_ROLE_GROUPS.find((g) => list.includes(g)) ?? null;
}

/**
 * Groups to save: the chosen role plus every group the user already had that isn't a
 * ONE role (e.g. `twister_clients`), which this editor doesn't manage and leaves alone.
 */
export function mergeGroups(original: readonly string[] | null | undefined, role: string | null): string[] {
  const roles = new Set<string>(ONE_ROLE_GROUPS);
  const others = (original ?? []).filter((g) => !roles.has(g));
  return role ? [role, ...others] : others;
}
